import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { MyErrorHandler } from '../errorhandler/errorhandler';
import { ProjectmanagementService } from '../service/projectmanagement.service';
import { Country, Partner } from '../model/project.model';
import * as projectforms from '../forms/projectmanagement.form';
import { Dialog } from '@eds/vanilla';
import { ToolsService } from '../../../../tools/src/lib/tools.service';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import * as languageConfig from '../../../../../src/assets/i18n/configuration/configuration.json';
declare var jQuery;
@Component({
  selector: 'app-projectmanagement',
  templateUrl: './projectmanagement.component.html',
  styleUrls: ['./projectmanagement.component.css']
})
export class ProjectmanagementComponent implements OnInit {
  @ViewChild('container') pmContainer: ElementRef;
  sub;
  error;
  environment;

  message;

  titleMessage; // success message for alert modal
  subTitleMessage; // success message for alert modal
  detailMessage; // success message for alert modal
  detailMessageLine1; // success message for alert modal
  detailMessage1;
  detailMessage2;
  detailMessage3;

  term;
  loaded = false;
  gridView = true;
  project_id = '';

  projectCount = 0;
  schoolCount = 0;
  studentCount = 0;
  teacherCount = 0;
  adminCount = 0;

  textDir:any;
  page = 1;
  noOfItems = 9;

  btnTextAdd = 'Add';
  btnStatusAdd = true;
  btnTextCancel = 'Cancel';

  filterredCountry = '';
  filterredPartner = '';
  filterredStatus = '';
  projectForm;

  partners = [];
  countries = [];
  partnerFilter = [];
  countryFilter = [];
  statusFilter = [
    {name: 'Active', state: 'true'},
    {name: 'Archived', state: 'false'}
  ];

  projectList = [];
  projectIconColor = {
    stringToColorHash: {},
    nextVeryDifferntColorIdx: 1,
    veryDifferentColors: [ '#7b0864', '#7b0864']
  };

  filterBy = {
    active: '',
    partners: '',
    country: ''
  };

  order = 'desc';

  // options for pagination
  public rowsOnPage = 9;
  public sortOrder = 'asc';
  countrySelectConfig: any;
  selectedCountry: Country;
  partnerSelectConfig: any;
  
  selectedPartner: Partner;
  statusSelectConfig: any;
  selectedStatus: any;

  config: any;

  /* Sorting variables */
  propertyName: string;
  propertyNameSorting: string;
  orderType = true;
  isSorted = false;
  sortedClass: string;
  languageConfiguration: any;

  searchPlaceHolder: any;
  constructor(
    private router: Router,
    public translate: TranslateService,
    private projectmanagementService: ProjectmanagementService,
    private routeParams: ActivatedRoute,
    private util: ToolsService ) {
      this.config = {};
      this.languageConfiguration = (languageConfig as any).default;
      translate.addLangs([this.languageConfiguration.languages]);
      translate.setDefaultLang(this.languageConfiguration.defaultLang);
      let selectedLang = sessionStorage.getItem('selectedLang');
      this.textDir = sessionStorage.getItem('textDir');
     
      let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
      if(selectedLang){
        translate.use(selectedLang.match(langRegExp) ? selectedLang : this.languageConfiguration.defaultLang);  
      } else {
        const browserLang = translate.getBrowserLang();                  
        translate.use(browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);  
      }     
    }

  ngOnInit(): void {
    this.environment = environment;
    if (localStorage.getItem('loginInfoObj') == null) {
        this.router.navigate(['/login']);
    }
    const userData = JSON.parse(localStorage.getItem('loginInfoObj'));
    this.projectForm = projectforms.projectForm;
    this.textDir = sessionStorage.getItem('textDir');
    this.propertyNameSorting = 'name';

    if (userData.project && userData.project._id) {
      this.myproject(userData.project._id);
    }

    this.translate.get('All lead partners').subscribe((translated: string) => {
      this.partnerSelectConfig = {
        placeholder: translated ,
        displayKey: 'name',
        search: true,
        height: '250px',
        searchPlaceholder:this.translate.instant('Search'),
        customComparator: ((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }    
          // names must be equal
          return 0;
        })
      };
      this.countrySelectConfig = {
        placeholder: this.translate.instant('All countries'),
        displayKey: 'name',
        search: true,
        height: '250px',
        searchPlaceholder: this.translate.instant('Search'),
        customComparator: ((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
    
          // names must be equal
          return 0;
        })
      };
      this.statusSelectConfig = {
        placeholder: this.translate.instant('Active & archived'),
        displayKey: 'name',
        search: false,
        height: '100px'
      };
    });

    this.getprojectlistData();
    this.getfilteredData('sortOrder', 'default');

    /* this is for success alert start*/
    if (window.localStorage.getItem('projectaddsuccess')) {

        this.titleMessage = 'New project added';
        this.subTitleMessage = window.localStorage.getItem('projectName') + ', ' + window.localStorage.getItem('projectCountryName');
        this.detailMessage = 'The appointed administrator will receive access details via email';
        //this.detailMessageLine1 = 'Please notify the recipient that this email may get filtered to their Spam or Junk mail folder.';
        this.detailMessageLine1 = '';
        window.localStorage.removeItem('projectaddsuccess');
        window.localStorage.removeItem('projectName');
        window.localStorage.removeItem('projectCountryName');
        this.openDialogModal('successModal');
        /* IMPORTANT */
        /* Need to implement EDS Dialog here */
    }
    this.setGrid();
  }

  initProject() {
    this.countries = [];
    this.partners = [];
    this.projectmanagementService.initAddProj().subscribe(
      data => {
        this.countries = data[0];
        this.partners = data[1];
      }
    );
  }

  openDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }

  getprojectlistData() {
    this.loaded = false;
    this.projectmanagementService.list().subscribe(
      (response) => {
        this.projectList = response;
        this.projectCount =  this.projectList.length;
        this.projectList.forEach(item => {
          this.schoolCount = this.schoolCount + item.schoolCount;
          this.studentCount = this.studentCount + item.studentCount;
          this.teacherCount = this.teacherCount + item.teacherCount;
          this.adminCount = this.adminCount + item.padminCount;
      });
        this.loaded = true;
      },
      (err) => {
        console.log('ERROR: ' + err.status);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          console.log('message ' + 'before login redirect');
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
       // console.log('COMPLETED');
      }
    );
  }

  getPartnerData() {
      /*
    this._projectmanagementService.getPartnerlistspecificToProject().subscribe(
      (response) => {
        this.partners = response;
      },
      (err) => {
        console.log('ERROR: ' + err.status);
        let errorHandler = new ErrorHandler(err);
        if (errorHandler.isSssionExpired) {
          this._router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );*/
      this.projectList.forEach(function(item){
          this.partners.push(item.partners);
      });
  }

  getCountryData() {
      //
      /*
    this._projectmanagementService.listCountry().subscribe(
      (response) => {
        this.countries = response;
        //this.refreshSelect('country');
      },
      (err) => {
        console.log('ERROR: ' + err.status);
        let errorHandler = new ErrorHandler(err);
        if (errorHandler.isSssionExpired) {
          this._router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );*/

  }

  getfilteredData(filterType, data) {
    const filterList = { sort_by: '_id', sort_order: 'desc', 'filter_by': null, 'filter_value': null };

    if (filterType === 'sortOrder') {

      if (data === 'default') {
        this.order = 'desc';
      }

      if (data === 'toggle') {
        if (this.order === 'desc') {
          this.order = 'asc';
        } else {
          this.order = 'desc';
        }
      }
      filterList.sort_order = this.order;
    }

    if (data) {
      if (filterType === 'status') {
        this.filterBy.active = data;
        this.filterredStatus = data;
      } else if (filterType === 'partnerId') {
        this.filterBy.partners = data;
        this.filterredPartner = data;
      } else if (filterType === 'countryId') {
        this.filterBy.country = data;
        this.filterredCountry = data;
      }
    } else {
      if (filterType === 'status') {
        delete this.filterBy.active;
      } else if (filterType === 'partnerId') {
        delete this.filterBy.partners;
      } else if (filterType === 'countryId') {
        delete this.filterBy.country;
      }
    }

    Object.keys(this.filterBy).forEach(key => {
      //
      if (this.filterBy[key]) {
        if (filterList.filter_by) {
          filterList.filter_by = filterList.filter_by + ',' + key;
          filterList.filter_value = filterList.filter_value + ',' + this.filterBy[key];
        } else {
          filterList.filter_by = key;
          filterList.filter_value = this.filterBy[key];
        }
      }
    });

    this.loaded = false;
    this.projectmanagementService.search(filterList).subscribe(
      (response) => {
        this.projectList = response;
        if (data === 'default') {
          this.partnerFilter = new Array();
          this.countryFilter = new Array();
        }
        this.projectList.forEach((item, index) => {
          if (data === 'default') {
            const p = item.partners.filter(x => x.type === 'Lead Partner');
            if (p && p.length && p[0].partner) {
              this.partnerFilter.push(p[0].partner);
              this.projectList[index].leadPartner = p[0].partner.name;
            }
            this.countryFilter.push(item.country);
          }
        });
        this.loaded = true;
      },
      (err) => {
        console.log('ERROR: ' + err.status);
        this.loaded = true;
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }else{
          this.openServerErrorDialog();
        }
      },
      () => {
      //  console.log('COMPLETED');
      }
    );
  }

  openServerErrorDialog(){
    this.titleMessage = 'Server or network error';
    this.detailMessage1 = 'A server or network error has occurred. Please try again later.';
    this.detailMessage2 = 'If this error persists contact your system administrator.';
    this.openDialogModal('errorModal');
  }

  callType(deviceValue) {
    console.log(deviceValue);
  }
  setGrid() {
   this.gridView = true;
   this.noOfItems = 9;
   this.page = 1;
  //  this.getfilteredData('default', 'default');
  }
  setList() {
    this.gridView = false;
    this.noOfItems = 18;
    this.page = 1;
    // this.getfilteredData('default', 'default');
  }

  pageChanged(ev){
    this.page = ev;
    /* Scroll to top functionality */
    const scrollToTop = () => {
      const c = this.pmContainer.nativeElement.scrollTop;
      if (c > 0) {
        window.requestAnimationFrame(scrollToTop);
        this.pmContainer.nativeElement.scrollTo(0, c - c / 8);
      }
    };
    scrollToTop();
  }

  reloadPage() {
    window.location.reload();
  }

  enableDisableProject(obj) {
    if (obj.active === true) {
      this.disableProject(obj);
    } else {
      this.enableProject(obj);
    }
  }
  disableProject(obj) {
    this.projectmanagementService.disable(obj._id).subscribe(
      (response) => {
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
        this.getfilteredData('sortOrder', this.order);
      }
    );
  }

  enableProject(obj) {
    this.projectmanagementService.enable(obj._id).subscribe(
      (response) => {
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
        this.getfilteredData('sortOrder', this.order);
      }
    );
  }

  addNew() {
    this.router.navigate(['addproject'], {relativeTo: this.routeParams});
  }

  editProjectModal(item) {
    this.btnTextAdd = 'Update';
    this.btnStatusAdd = false;
    this.btnTextCancel = 'Cancel';
    this.error = '';
    this.message = '';

    this.projectForm.patchValue(item);
    this.projectForm.get('country').patchValue(item.country.name);
    this.projectForm.get('partners').patchValue(item.partners);
    this.projectForm.get('partner').patchValue(item.partners[0].name);
    this.project_id = item._id;

    if (this.projectForm.errors) {
      this.btnStatusAdd = true;
    } else {
      this.btnStatusAdd = false;
    }
    jQuery('#projectModal').modal('show');
    if (this.message) {
        this.reloadPage();
    }
  }

  projectFormChange(flag) {
    if (flag && this.projectForm.invalid) {
      this.btnStatusAdd = true;
    } else {
      this.btnStatusAdd = false;
    }
  }

  editProject() {
    // redirect on success
    if (this.projectForm.invalid) {
      this.btnStatusAdd = true;
      return;
    }
    const data = this.projectForm.value;
    data.partners = [];
    data.country = this.projectForm.get('country').value._id;
    data.admins = [];

    if (!data.logo) {
      delete data.logo;
    }

    delete data.partner;
    delete data.admins;

    this.projectForm.get('partners').value.forEach(element => {
      data.partners.push(element._id);
    });

    this.projectmanagementService.update(this.project_id, JSON.stringify(data)).subscribe(
      (response) => {
        this.message = this.translate.instant('Project updated Succesfully');
        this.btnTextCancel = 'Close';
        this.btnTextAdd = '';
      },
      (err) => {
        console.log('ERROR: ' + err);
        this.error = err;
        this.message = this.translate.instant('Project Update Failed');
        this.btnTextCancel = 'Cancel';
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          jQuery('#projectModal').modal('show');
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.getfilteredData('sortOrder', this.order);
      }

    );
  }

  cancelProject() {
    //
  }

  gotoProjectOverview(obj) {
    const navigationExtras: NavigationExtras = {
      relativeTo: this.routeParams,
    };
    this.router.navigate([obj._id, 'view'], navigationExtras);
  }

  renderSelect(item) {
    if ( item === 'country') {
      jQuery('#selectCountry').selectpicker('render');
    } else if (item === 'partner') {
      jQuery('#selectPartner').selectpicker('render');
    } else if ( item === 'status') {
      jQuery('#selectStatus').selectpicker('render');
    }
 }

 refreshSelect(item) {
   if ( item === 'country') {
     jQuery('#selectCountry').selectpicker('refresh');
   } else if (item === 'partner') {
     jQuery('#selectPartner').selectpicker('refresh');
   } else if ( item === 'status') {
     jQuery('#selectStatus').selectpicker('refresh');
   }
 }
  myproject(project_id) {
      this.router.navigate(['/projectmanagement', project_id,'view']);
  }

  fixLogoUrl(url?) {
    if (url) {
    if (url.match('undefined')) {
      return url.replace('undefined', environment.msdpAPIBaseURL);
    } else if (url.match('FILEBASEURL')) {
      return url.replace('<FILEBASEURL>', environment.msdpAPIBaseURL);
    } else {
      return url;
    }
    }
    return 'null';
  }

  tabHeadingInitial(data){
    let temp1, temp2;
    if (data !== undefined)
    {
      const temp = data.split(' ');
      temp1 = temp[0].charAt(0).toUpperCase();
      if (temp.length > 1) {
        temp2 = temp[1].charAt(0).toLowerCase();
      } else {
        temp2 = temp[0].charAt(1).toUpperCase();
      }
    }
    return temp1 + temp2;
  }

  /* Sorting functionality added - KAJAL */
  sortByDefault(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    this.orderType = true;
    this.propertyNameSorting = propertyName;
  }
  sortBy(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    if (propertyName !== null && this.propertyName === propertyName){
      if (this.orderType === true){
        this.orderType = false;
        this.propertyNameSorting = propertyName;
        this.sortedClass = 'asc';
      }else{
        this.orderType = true;
        this.propertyNameSorting = '-' + propertyName;
        this.sortedClass = 'desc';
      }
    }
  }

  downloadCsv(data, type){
    this.util.generateCSV(data, type);
  }
  
}
